import CardBase from "../../../../UI/Card/CardBase/CardBase";
import classes from "./RenewPlanPix.module.scss";
import paymentCard from "../../../../../assets/images/payment_card.svg";
import * as helpers from "../../../../../helpers/index";
import { setAnalyticsClickDashCardMyPanelMoreInfo } from "../../../../../helpers/analyticsHelpers";
import { PROBRAIN_LINK } from "../../../../../constants/api";
import moment from "moment";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as routes from "../../../../../constants/routes";

const RenewPlanPix = ({ }) => {
  const { t } = useTranslation();
  const { session } = useSelector((state) => state.session);
  const navigate = useNavigate();
  return (
    <div className={classes.RenewPlanPix}>
      <div className={classes.Title}>
        {`${t("purchase.your_plan_can_be_renewed_from")} ${moment(
          session.plans.active_base_plan[0].next_charge
        ).format("DD/MM/YYYY")}`}
      </div>
      <div className={classes.Items}>
        <div>{t("purchase.identified_payment_pix")}</div>
        <div>{`${t("purchase.wait_until_the_purchased_period_expires_in")} ${moment(
          session.plans.active_base_plan[0].next_charge
        ).format("DD/MM/YYYY")}.`}</div>
        <div>{t("purchase.your_account_and_user_data_will_be_retained")}</div>
      </div>
      <button
        onClick={() => {
          navigate(routes.R_MY_ACCOUNT);
          setAnalyticsClickDashCardMyPanelMoreInfo({
            type: session.my_user.typeUser,
            profile: session?.my_user?.profile,
          });
        }}
        className={classes.BtnManage}
      >
        {t("purchase.manage_my_plan_pix")}
      </button>
      <CardBase classPrimary={classes.CardRenew}>
        <img src={paymentCard} className={classes.Image} alt="" />
        <div className={classes.Bottom}>
          <div className={classes.Title}>
            {t("purchase.renew_plan_before_it_expires")}
          </div>
          <div className={classes.SubTitle}>
            {t("purchase.subscribe_to_afinando_using_your_credit_card")}
          </div>
          <div className={classes.Items}>
            <li>{t("purchase.does_not_use_your_card_limit")}</li>
            <li>
              {t("purchase.every_month_the_monthly_fee_will_be_debited_whithout_using_your_limit")}
            </li>
            <li>{t("purchase.always_have_tuning_active")}</li>
          </div>
        </div>
      </CardBase>
    </div>
  );
};
export default RenewPlanPix;
